import { useLocation } from 'react-router'
import { getVideoCallFlow } from '../types'

const normalizePathname = (pathname: string) => pathname.replace(/\/+$/, '') || '/'

// getVideoCallFlow() is rebuilt on every call, and the steps can come back in a
// different order while the app is running. The Dexcom/Stelo steps move once the
// Unleash flag loads. So the step has to be found by URL: an index kept from an
// earlier build of the flow can point at another step.
export const useFindCurrentStep = () => {
  const { pathname } = useLocation()
  const videoCallFlow = getVideoCallFlow()

  const index = videoCallFlow.findIndex(
    (step) => normalizePathname(step.location) === normalizePathname(pathname)
  )

  // This URL is not a step in the current flow, so the flow changed (a different
  // partner, for example). Fall back to the first step. It always counts as
  // done, so the layout sends the user on to the first step they still need.
  if (index === -1) {
    return { index: 0, step: videoCallFlow[0] }
  }

  return { index, step: videoCallFlow[index] }
}
